import { getItemHighlight, getSecondaryHighlight } from "./utils";

export function getOrganisationTemplate(item, html) {
  return html`<div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path
            d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
          />
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${getItemHighlight(html, item, "organisation.full_name", "no name")}
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "organisation.short_name")}

          <span class="orgid label label-default"
            >Org ID: ${item.document["organisation.identifier"]}</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
